// Template287: Bali - Consejos p.2 (Tips2.jsx)
// Cabecera verde, lista tips con borde verde, sticker.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template287 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const sticker = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const tips =
		Array.isArray(page?.data?.tips)
			? page.data.tips
			: Array.isArray(page?.data?.data?.tips)
			? page.data.data.tips
			: [];
	const actualHeaderColor = headerBackgroundColor || "#2F6B4F";
	const contentColor = textColor || "#444";

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": { fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`, color: "inherit" },
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box component="img" src={logoImage} alt="logo" sx={{ width: 66, position: "absolute", right: 2, top: 18, zIndex: 999999 }} />
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "0 16px 20px", display: "flex", flexDirection: "column", gap: 1.5, position: "relative", marginTop: 2.5, flex: 1, overflow: "auto" }}>
				{tips.map((tip, idx) => (
					<Box
						key={tip.icono + (tip.texto || "") + idx}
						data-block-id={`text-${idx + 2}`}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: 1.25,
							border: "2px solid #c8e6d4",
						}}
					>
						<Box component="span" sx={{ fontSize: 18 }}>{tip.icono}</Box>
						<Box
							component="span"
							sx={{ fontSize: 13, color: contentColor }}
							dangerouslySetInnerHTML={typeof tip.texto === "string" && tip.texto.includes("<") ? { __html: tip.texto } : undefined}
						>
							{typeof tip.texto === "string" && !tip.texto.includes("<") ? tip.texto : null}
						</Box>
					</Box>
				))}
				{sticker && (
					<Box
						component="img"
						src={sticker}
						alt=""
						sx={{
							width: isSmallScreen ? 80 : 100,
							position: "absolute",
							bottom: isSmallScreen ? -60 : -40,
							right: isSmallScreen ? -20 : -40,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template287.thumbnail = "/images/template-1.png";
export default Template287;
